import * as yup from "yup";
import type { Asserts } from "yup";

// Response from /shipment/{guid} validation

const shipmentSchema = yup.object({
  id: yup.string().required(),
  invoice: yup
    .object({
      privateName: yup.string().nullable().defined(),
      privateEmail: yup.string().nullable().defined(),
      companyName: yup.string().nullable().defined(),
      registryCode: yup.string().nullable().defined(),
      emailAddress: yup.string().nullable().defined(),
      vatNumber: yup.string().nullable().defined(),
      companyRegistrationAddress: yup.string().nullable().defined(),
    })
    .defined(),
  senderAddress: yup
    .object({
      name: yup.string().nullable().defined(),
      contactName: yup.string().nullable().defined(),
      contactEmail: yup.string().nullable().defined(),
      contactPhone: yup.string().nullable().defined(),
      contactInfo: yup.string().nullable().defined(),
      email: yup.string().nullable().defined(),
      phone: yup.string().nullable().defined(),
      street: yup.string().nullable().defined(),
      streetNo: yup.string().nullable().defined(),
      flatNo: yup.string().nullable().defined(),
      city: yup.string().nullable().defined(),
      postalCode: yup.string().nullable().defined(),
      country: yup.string().nullable().defined(),
      countryCode: yup.string().nullable().defined(),
      pudoId: yup.string().nullable().defined(),
      lockerName: yup.string().nullable().defined(),
    })
    .defined(),
  receiverAddress: yup
    .object({
      addressId: yup.string().nullable().defined(),
      name: yup.string().nullable().defined(),
      contactInfo: yup.string().nullable().defined(),
      email: yup.string().nullable().defined(),
      phone: yup.string().nullable().defined(),
      street: yup.string().nullable().defined(),
      streetNo: yup.string().nullable().defined(),
      flatNo: yup.string().nullable().defined(),
      city: yup.string().nullable().defined(),
      postalCode: yup.string().nullable().defined(),
      country: yup.string().nullable().defined(),
      countryCode: yup.string().nullable().defined(),
      pudoId: yup.string().nullable().defined(),
      lockerName: yup.string().nullable().defined(),
    })
    .defined(),
  willCustomerPrintLabel: yup.bool().nullable().defined(),
  offerGroupId: yup.string().required(),
  coupon: yup.string().nullable().defined(),
  pickup: yup
    .object({
      pickupDate: yup.string().nullable().defined(),
      pickupTimeFrom: yup.string().nullable().defined(),
      pickupTimeTo: yup.string().nullable().defined(),
    })
    .nullable()
    .defined(),
  affiliateGuid: yup.string().nullable().defined(),
  dimension: yup.string().nullable().defined(),
  deliveryMethod: yup.string().nullable().defined(),
  price: yup.number().nullable().defined(),
  originalPrice: yup.number().nullable().defined(),
  parcelWeight: yup.string().nullable().defined(),
});

export type TShipmentResponse = Asserts<typeof shipmentSchema>;

const validateShipmentResponse = (response: any): TShipmentResponse => shipmentSchema.validateSync(response);

export default validateShipmentResponse;
